import { gql } from '@apollo/client';

/**
{
    "input": {
      "all": true,
      "q": "",
      "dates": [],
      "page": 1,
      "perPage": 10,
      "sort": "",
      "sortColumn": "",
      "pillar": "EMPTY"
    }
} 
 */

export const GetRankingRoads = gql`
  mutation GetRankingRoads($input: SearchRoadsFiltersInput!) {
    getRankingRoads(input: $input) {
      totalPillars {
        emotions
        purpose
        relations
        selfEsteem
        transformation
      }
      totalPages
      totalDocs
      limit
      page
      docs {
        cover
        membership
        started
        finished
        name
        likes
        episodes
        status
      }
    }
  }
`;

export const GetRankingEmotionsRoads = gql`
  mutation GetRankingByTagEmotions($input: SearchRoadsFiltersInput!) {
    getRankingByTagEmotions(input: $input) {
      docs {
        _id
        name
        description
        membership
        cover
        status
        new
        started
        finished
        episodes
        likes
        tags {
          name
        }
      }
      limit
      page
      totalDocs
      totalPages
    }
  }
`;
